import { useTranslation } from "react-i18next";

import { QuestionResultStatusSelector } from "modules/AppointmentDetails/components/Checks/components/Check/components/QuestionResults/components";

import type { QuestionResult } from "models";

type QuestionResultSectionProps = {
  questionResult: QuestionResult;
};

export const QuestionResultSection = ({ questionResult }: QuestionResultSectionProps) => {
  const { t } = useTranslation();

  return (
    <div className="question-result-section">
      <div className="title">{t("v8_question_result", "Question result")}</div>
      <div className="status-name-container">
        <h2 className="name-text">{questionResult.title}</h2>
        <QuestionResultStatusSelector disabled={true} questionResult={questionResult} />
      </div>
      <div className="description">{questionResult.raw}</div>
    </div>
  );
};
